export default __webpack_public_path__ + "static/media/polygon-network.be13acb2.svg";